/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon16Light = forwardRef('UiMenuDots9Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M4 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
